import { generateConfigurations } from "@/helpers/productDetails";
import { useClient } from "@/hooks/useClient";
import { v4 as uuidv4 } from "uuid";
import { useEffect } from "react";

export default function ProductConfigurations({ product, setProduct, t }) {
  const configurations = generateConfigurations(product);
  const { isClient } = useClient();

  useEffect(() => {
    function setConfigurations(configs) {
      setProduct((prev) => ({
        ...prev,
        selectedConfigurations: { ...prev?.selectedConfigurations, ...configs },
      }));
    }
    return setConfigurations(configurations);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClient]);

  return (
    <section className="py-4 space-y-5">
      {Object.entries(product?.option_details).map((op, key) => (
        <div key={key} className="*:mb-1.5">
          <div className="flex items-center gap-2">
            <span className="max-sm:text-xs text-[15px]">
              {t("Configuration")} :{" "}
            </span>
            <div className="font-bold max-sm:text-xs text-[15px]">
              {t(op[0])}
            </div>
          </div>
          <div className="flex items-center gap-3">
            {op[1].map((opDetail) => (
              <div
                onClick={() => {
                  setProduct((prev) => ({
                    ...prev,
                    selectedConfigurationsImg:
                      opDetail?._media_?.image?.[0]?.image || null,
                    selectedConfigurations: {
                      ...prev?.selectedConfigurations,
                      [op[0]]: opDetail,
                    },
                  }));
                }}
                key={uuidv4()}
                className={`bg-${
                  // product?.selectedConfigurations &&
                  opDetail.option_id ==
                  product?.selectedConfigurations?.[op?.[0]]?.option_id
                    ? "primary text-white"
                    : "zinc-300"
                } cursor-pointer py-1 px-4 rounded-lg text-center text-[10px] sm:text-sm`}
              >
                {t(opDetail.label || opDetail.lable)}
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
